import { styled } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";

export const StyledRightSection = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
});

export const StyledCustomerName = styled("span")({
  paddingLeft: "24px",
  paddingRight: "14px",
  fontStyle: "normal",
  fontSize: "16px",
  fontWeight: "400",
  fontFamily: "'Inter', sans-serif",
  color: "#fff",
  letterSpacing: "0.1px",
  whiteSpace: "nowrap",
  lineHeight: "20px",
  textTransform: "capitalize",
});

export const StyledLanguageIcon = styled(LanguageIcon)({
  width: 40,
  height: 40,
  color: "white",
  cursor: "pointer",
  marginLeft: "12px",
});

export const StyledProfileIconButton = styled(IconButton)({
  padding: 0,
});

export const StyledAvatarWrapper = styled("div")({
  width: 80,
  textAlign: "-webkit-center",
});

export const StyledAvatar = styled(Avatar)({
  backgroundColor: "white",
  color: "#333",
});